'use client'

import I18nTranslator from '@/app/_components/Shared/I18nTranslator/I18nTranslatorClient'
import { useSearchParams } from '@/libraries/search-params'
import { ReactNode, useCallback } from 'react'
import { twMerge } from 'tailwind-merge'
import { z } from 'zod'

function Filter({
  children,
  isSelected,
  onSelected,
}: {
  children: ReactNode
  isSelected: boolean
  onSelected: () => void
}) {
  return (
    <button
      type="button"
      onClick={onSelected}
      className={twMerge(
        'flex h-32 items-center justify-center rounded-100 bg-french-bleu px-20 font-noto-sans-kr text-16 font-normal',
        isSelected
          ? 'bg-french-bleu text-white'
          : 'bg-white text-[rgba(0,_0,_0,_0.4)] border border-solid border-[rgba(0,_0,_0,_0.40)]',
      )}>
      {children}
    </button>
  )
}

export function Filters() {
  const [state, setState] = useSearchParams(
    z.object({
      filter: z
        .union([z.literal('in-progress'), z.literal('ended'), z.literal('all')])
        .default('all'),
    }),
    'replace',
    {
      scroll: false,
    },
  )
  const setSelectedFilter = useCallback(
    (filter: 'in-progress' | 'ended' | 'all') => {
      setState({
        filter,
      })
    },
    [setState],
  )

  return (
    <div className="flex items-center gap-10">
      <Filter
        isSelected={state.filter === 'all'}
        onSelected={() => setSelectedFilter('all')}>
        {<I18nTranslator text="common.filterAll" />}
      </Filter>
      <Filter
        isSelected={state.filter === 'in-progress'}
        onSelected={() => setSelectedFilter('in-progress')}>
        {<I18nTranslator text="common.filterIng" />}
      </Filter>
      <Filter
        isSelected={state.filter === 'ended'}
        onSelected={() => setSelectedFilter('ended')}>
        {<I18nTranslator text="common.filterEnd" />}
      </Filter>
    </div>
  )
}
